import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import React, { Component } from 'react';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { withStyles } from '@material-ui/core';
import DateRangePicker from './lib/DateRangePicker';
var CustomDateRangePicker = withStyles({
  root: {
    border: '1px solid red'
  }
})(DateRangePicker);
var styles = {
  datepicker: {
    '& input, & input:hover': {
      border: 'none !important'
    }
  }
};
var DATE_FORMAT = 'MMM d, yyyy';

var KailonaDateRangePicker = /*#__PURE__*/function (_Component) {
  _inherits(KailonaDateRangePicker, _Component);

  var _super = _createSuper(KailonaDateRangePicker);

  function KailonaDateRangePicker(props) {
    var _this;

    _classCallCheck(this, KailonaDateRangePicker);

    _this = _super.call(this, props);
    _this.state = {
      dateFormat: _this.props.dateFormat || DATE_FORMAT
    };
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(KailonaDateRangePicker, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.defaultValue) {
        this.setState({
          date: this.props.defaultValue
        });
      }
    }
  }, {
    key: "handleChange",
    value: function handleChange(date) {
      this.setState({
        date: date
      });

      if (this.props.onChange && typeof this.props.onChange === 'function') {
        this.props.onChange(date);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var classes = this.props.classes;
      return /*#__PURE__*/React.createElement(MuiPickersUtilsProvider, {
        utils: DateFnsUtils
      }, /*#__PURE__*/React.createElement(CustomDateRangePicker, {
        variant: "inline",
        className: classes.datepicker,
        format: this.state.dateFormat,
        id: this.props.id,
        value: this.state.date,
        placeholder: t('ehr', 'Select Date'),
        onChange: this.handleChange,
        maxDate: this.props.maxDate,
        KeyboardButtonProps: {
          'aria-label': this.props.ariaLabel
        },
        autoOk: true
      }));
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return KailonaDateRangePicker;
}(Component);

var _default = withStyles(styles)(KailonaDateRangePicker);

export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(CustomDateRangePicker, "CustomDateRangePicker", "/home/runner/html/nextcloud/apps/ehr/js/platform/ui/src/elements/DatePicker/KailonaDateRangePicker.js");
  reactHotLoader.register(styles, "styles", "/home/runner/html/nextcloud/apps/ehr/js/platform/ui/src/elements/DatePicker/KailonaDateRangePicker.js");
  reactHotLoader.register(DATE_FORMAT, "DATE_FORMAT", "/home/runner/html/nextcloud/apps/ehr/js/platform/ui/src/elements/DatePicker/KailonaDateRangePicker.js");
  reactHotLoader.register(KailonaDateRangePicker, "KailonaDateRangePicker", "/home/runner/html/nextcloud/apps/ehr/js/platform/ui/src/elements/DatePicker/KailonaDateRangePicker.js");
  reactHotLoader.register(_default, "default", "/home/runner/html/nextcloud/apps/ehr/js/platform/ui/src/elements/DatePicker/KailonaDateRangePicker.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();